(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["specs-parsing"] && !Shopify.designMode) return;
  try {
    class SpecAccordionContent extends HTMLElement {
    constructor() {
      super();
      this.parentAccordionDisclosure = this.closest('accordion-disclosure');
    }

    connectedCallback() {
      if (this.checkIfSpecsAreEmpty()) {
        this.parentAccordionDisclosure.remove();
      }
    }

    checkIfSpecsAreEmpty() {
      const specs = this.querySelectorAll('.specs-list__item');
      return specs.length === 0;
    }
  }

  if (!customElements.get('spec-accordion-content')) {
    customElements.define('spec-accordion-content', SpecAccordionContent);
  }
  } catch(e) { console.error(e); }
})();

})();
